/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const ColorFillIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Color Fill',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33.727 23.672a64.346 64.346 0 0 0-1.306-6.632c-.624-2.436-2.919-2.98-5.34-3.308l-8.107-8.107a1 1 0 0 0-1.415 0l-2.424 2.43 4.872 4.872a1.5 1.5 0 1 1-2.121 2.121l-4.872-4.872L1.856 21.334a1 1 0 0 0 0 1.415l10.753 10.739a1 1 0 0 0 1.414 0l15.571-15.594a1 1 0 0 0 .015-1.4.38.38 0 0 1 .566.149c.5.938.69 2.8-.528 5.574-.377.86-1.388 2.148-1.388 3.256a2.516 2.516 0 0 0 2.779 2.8c1.642.001 2.995-1.54 2.689-4.601ZM15.131 8.05 9.4 2.317a1.5 1.5 0 0 0-2.124 2.121l5.733 5.733Z"
    />
  </svg>`;
};
